import request from "../utils/request";

export const get = (id) => request.get(`/api/announcement/${id}`);
export const list = (data) => request.get("/api/announcement", data);
export const create = (data) => request.post("/api/announcement", data);
export const update = (id, data) => request.put(`/api/announcement/${id}`, data);
